import Vue from 'vue'
import Vuex from 'vuex'
import memu from './modules/memu'

Vue.use(Vuex)

export default new Vuex.Store({
    modules:{
        memu
    }
})